class FeaturedCollectionNew extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.onSliderReady = this.initSliders.bind(this);
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.onSliderReady, { once: true });
    } else {
      this.initializationFrame = requestAnimationFrame(this.onSliderReady);
    }
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.initializationFrame);
    this.removeReadyListeners();
  }

  removeReadyListeners() {
    document.removeEventListener('DOMContentLoaded', this.onSliderReady);
    if (this.tinySliderScript) {
      this.tinySliderScript.removeEventListener('load', this.onSliderReady);
      this.tinySliderScript = null;
    }
  }

  initSliders() {
    if (this.initialized || !this.isConnected) return;

    // Section scripts can run before the deferred library in the footer.
    if (typeof tns !== 'function') {
      if (!this.tinySliderScript) {
        this.tinySliderScript = document.querySelector('script[src*="VENDOR_tiny-slider.js"]');
        if (this.tinySliderScript) {
          this.tinySliderScript.addEventListener('load', this.onSliderReady, { once: true });
        }
      }
      document.addEventListener('DOMContentLoaded', this.onSliderReady, { once: true });
      return;
    }

    this.removeReadyListeners();
    this.mainSlider = this.querySelector(".sliderNew");
    this.innerSlider = this.querySelectorAll(".innerslider");

    if (this.mainSlider && this.mainSlider.children.length > 0) {
      this.initialized = this.init(this.mainSlider, this.innerSlider);
    }
  }

  init(firstSlide, innerSlider) {

    // Initialize main slider with Tiny Slider
    if (firstSlide && firstSlide.children.length > 0 && firstSlide.parentNode && firstSlide.parentNode.nodeType === 1) {
      try {
        // Calculate startIndex to center the active slide
        var slideCount = firstSlide.children.length;
        var startIndex = Math.floor(slideCount / 2);
        
        this.sliderInstance = tns({
          container: firstSlide,
          items: 1.55,
          slideBy: 1,
          nav: false,
          controls: true,
          controlsText: [
            '<span class="visually-hidden">Previous products</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.79 45.18"><polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" points="43.29 22.54 1.74 22.54 21.74 1.5 1.5 22.54 21.74 43.68"/></svg>',
            '<span class="visually-hidden">Next products</span><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.79 45.18"><polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" points="1.5 22.63 43.05 22.63 23.05 43.68 43.29 22.63 23.05 1.5"/></svg>'
          ],
          mouseDrag: true,
          loop: true,
          autoplay: false,
          gutter: 0,
          center: true,
          startIndex: startIndex,
          responsive: {
            640: { items: 2 },
            900: { items: 3 },
            1200: { items: 3.9 },
            1410: { items: 4.75 },
            1660: { items: 5.6 },
            2000: { items: 6.75 }
          }
        });

        // Set equal height after initialization
        setTimeout(() => {
          this.setEqualHeight();
        }, 500);
      } catch (e) {
        console.error('Featured collection slider init error:', e);
        return false;
      }
    }

    if (!this.sliderInstance) return false;

    // Initialize inner sliders
    for (var i = 0, len = innerSlider.length; i < len; i++) {
      var innerSliderSingle = innerSlider[i];
      if (innerSliderSingle && innerSliderSingle.children.length > 0 && innerSliderSingle.parentNode && innerSliderSingle.parentNode.nodeType === 1) {
        try {
          tns({
            container: innerSliderSingle,
            items: 1,
            slideBy: 1,
            controls: true,
            nav: false,
            loop: false,
            mouseDrag: false,
            autoplay: false,
            gutter: 0
          });
        } catch (e) {
          console.error('Inner slider init error:', e);
        }
      }
    }
    // Update height on window resize
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.setEqualHeight();
      }, 200);
    });
    return true;
  }

  // Method to set equal height for elements
  setEqualHeight() {
    const slides = this.mainSlider ? this.mainSlider.querySelectorAll('.slideNew') : [];
    if (slides.length === 0) return;

    // Reset height for correct recalculation
    slides.forEach(slide => {
      slide.style.height = 'auto';
      slide.style.minHeight = 'auto';
    });

    // Wait a bit for correct calculation
    setTimeout(() => {
      let maxHeight = 0;
      const viewportHeight = window.innerHeight;
      // Set a reasonable max limit (e.g., 150% of viewport height)
      const maxReasonableHeight = viewportHeight * 1.5;

      // Find max height
      slides.forEach(slide => {
        const slideHeight = slide.getBoundingClientRect().height;
        // Only consider heights that are reasonable (not 0 and not absurdly large)
        if (slideHeight > maxHeight && slideHeight < maxReasonableHeight && slideHeight > 50) {
          maxHeight = slideHeight;
        }
      });

      // Set equal height for all elements (only if we found a valid height)
      if (maxHeight > 0 && maxHeight < maxReasonableHeight) {
        slides.forEach(slide => {
          slide.style.height = maxHeight + 'px';
          slide.style.minHeight = maxHeight + 'px';
        });
      }
    }, 100);
  }
}


customElements.define('featured-collection-new', FeaturedCollectionNew);

// Updated logic to show/hide buttons
if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function ($) {
    setTimeout(function () {
      $(".feat-col-new__slider").each(function () {
        var $slider = $(this);
        var slideCount = $slider.find(".slideNew").length;
        var $buttons = $slider.find("[data-controls]");

        if (slideCount > 4) {
          $buttons.show();
        } else {
          $buttons.hide();
        }
      });
    }, 500);
  });
}

